import React, { useState } from "react";
import LoginForm from "./LoginForm";
import ForgetPassForm from "./ForgetPassForm";
import { Box, Typography } from "@mui/material";

const LoginBox = ({ handleClose, navigate, isReLogin = false, expirationTime = 0 }) => {
  const [currentModal, setCurrentModal] = useState({
    name: "login",
    content: {
      email: "",
    },
  });

  const handleLoginPages = () => {
    if (currentModal.name === "login") {
      return (
        <LoginForm
          handleClose={handleClose}
          isReLogin={isReLogin}
          navigate={navigate}
          currentModal={currentModal}
          setCurrentModal={setCurrentModal}
          expirationTime={expirationTime}
        />
      );
    }
    if (currentModal.name === "forget-password") {
      return (
        <ForgetPassForm
          handleClose={handleClose}
          currentModal={currentModal}
          setCurrentModal={setCurrentModal}
        />
      );
    }
  };

  return (
    <Box sx={styles.container(isReLogin)}>
      <Box sx={styles.img} component="img" id="logo" src="/assets/logo_gt.png" alt="company logo" />
      {!isReLogin && (
        <Typography variant="h5" sx={styles.title}>
          Área do Cliente
        </Typography>
      )}

      <Box sx={{ display: "flex", flexFlow: "column", width: "100%", mt: 1 }}>{handleLoginPages()}</Box>

      {!isReLogin && (
        <Box sx={styles.footerInfo}>
          <Typography variant="button">
            Ainda não é cliente?{" "}
            <a
              href="https://wa.me/5571992084907?text=Gostaria%20de%20saber%20mais%20sobre%20o%20sistema%20Gestão%20tributária"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              Falar com especialista
            </a>
          </Typography>
          <Typography variant="caption" sx={{ mt: 1 }}>
            © Gestão Tributária - Todos os Direitos Reservados <br />
            Este é um serviço da <a href="https://opensolucoestributarias.com.br/" target="_blank" rel="noreferrer" style={styles.link}><b>Open Soluções Tributárias</b></a>.
          </Typography>
        </Box>
      )}

      {/* Versão do Sistema - Canto inferior esquerdo */}
      <Box sx={styles.versionContainer}>
        <Typography variant="caption" sx={styles.versionText}>
          v1.0.32
        </Typography>
      </Box>
    </Box >
  );
};

export default LoginBox;

const styles = {
  container: (isReLogin) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly",
    padding: isReLogin ? "38px 26px 44px" : "38px 16px 44px",
    width: isReLogin ? "388px" : "450px",
    maxWidth: "100%",
    minHeight: "480px",
    "@media screen and (min-width: 425px)": {
      padding: isReLogin ? "38px 41px 44px" : "38px 24px 44px",
    },
  }),
  title: {
    fontWeight: 600,
    color: "#121110",
    mt: 1,
    mb: 2,
  },
  img: {
    width: "176px",
    marginBottom: "8px",
    alignSelf: "center",
  },
  footerInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    mt: 3,
    textAlign: "center",
    color: "#888888", // Cinza médio discreto
    fontFamily: "Montserrat",
  },
  link: {
    color: "#000000ff",
    textDecoration: "none",
    fontWeight: 400,
  },
  versionContainer: {
    position: "fixed",
    bottom: "16px",
    left: "16px",
    opacity: 0.6,
  },
  versionText: {
    color: "#000000ff",
    fontFamily: "Montserrat",
    fontSize: "0.7rem",
  }
};
